<template lang="html">
  <section id="sol_campaign" class="sol_campaign">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <h3 class="card-text margin-b-md">Filters</h3>
              <hr>
              <b-row class="just-sb m-0">
                <div class="col-lg-6 row">
                  <b-col class="col-lg-2 pt-2">Market:</b-col>
                  <b-select class="col-lg-10" v-model="selectedCountry" id="selectedCountry"  v-on:change="isPostPriceConf=false">
                    <b-form-select-option :value="null">---</b-form-select-option>
                    <b-form-select-option :value="country" v-for="(country,index) in countryList">{{country.description}}</b-form-select-option>
                  </b-select>
                </div>
                <div class="col-lg-6 row">
                <b-col class="col-lg-2 pt-2">Model:</b-col>
                  <b-select class="col-lg-10" v-model="filterObj.vetele"  id="selectedModel"  v-on:change="isPostPriceConf=false">
                    <b-form-select-option :value="null">---</b-form-select-option>
                    <template v-for="models in getModelList">
                      <optgroup :label="models.label">
                        <b-form-select-option v-for="(model,index) in models.items" :key="index" :value="model.value">{{model.solLabel}}</b-form-select-option>
                      </optgroup>
                    </template>
                  </b-select>
                </div>
              </b-row>
              <br>
              <b-row class="just-sb m-0">
                <div class="col-lg-6 row datepicker-row">
                    <div class="col-lg-2 label-column">Date Start From:</div>
                    <div class="datepicker-container col-lg-10">
                      <datepicker class="datepicker-input" format="dd/MM/yy" placeholder="date from" v-model="filterObj.dateStart"></datepicker>
                      <b-button class="p-1 m-auto" size="sm" style="max-width: 2.875rem; z-index:10" variant="primary" v-b-tooltip.hover title="empty date from" @click="emptydateFrom()">
                        <i  class="mdi mdi-close-box btn-outline-secondary" style="display: block;"></i>
                      </b-button>
                    </div>
                </div> 
                <div class="col-lg-6 row datepicker-row">
                    <div class="col-lg-2 label-column">Date Start To:</div>
                    <div class="datepicker-container col-lg-10">
                      <datepicker format="dd/MM/yy" placeholder="date to" v-model="filterObj.dateEnd"></datepicker>
                      <b-button class="p-1 m-auto" size="sm" style="max-width: 2.875rem; z-index:10" variant="primary" v-b-tooltip.hover title="empty date to" @click="emptydateTo()">
                        <i  class="mdi mdi-close-box btn-outline-secondary" style="display: block;" ></i>
                      </b-button>
                    </div>
                </div>
              </b-row>
              <b-row>
                <div class="col-lg-12 checkbox-container">
                  <label class="col-lg-1 pt-2" for="visible">Show active only</label>   
                  <input type="checkbox" id="visible" value="visible" v-model="filterObj.active">
                </div>
              </b-row>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-12">
              <h4 class="card-title">Discounts Campaigns:</h4>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-9"
                ></b-pagination>
                </div>              
               </div>
                <div class="col-lg-1">
                  <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-12">
                    <b-form-select-option value="5">5</b-form-select-option>
                    <b-form-select-option value="10">10</b-form-select-option>
                    <b-form-select-option value="15">15</b-form-select-option>
                    <b-form-select-option value="20">20</b-form-select-option>
                    <b-form-select-option value="50">50</b-form-select-option>
                    <b-form-select-option value="100">100</b-form-select-option>
                  </b-form-select>
              </div>
            <div class="col-lg-7">
              <span class="float-right">
                <template v-if="isFromPriceConf">
                  <b-button variant="primary mr-1" v-if="isFromPriceConf" @click="back()"><i class="mdi mdi-arrow-left"></i>Back To Price Configurator</b-button>  
                </template>
                <template v-else>
                  <b-button variant="primary mr-1" v-if="isFromPriceConf" @click="back()"><i class="mdi mdi-arrow-left"></i>Back To Price Configurator</b-button>
                  <b-button variant="primary mr-1" @click="refreshTable()"><i class="mdi mdi-refresh"></i>Apply</b-button>
                  <b-button variant="primary mr-1" v-b-toggle.filters><i class="mdi mdi-filter"></i></b-button>
                  <b-button variant="primary mr-1" v-b-modal.modal-new @click="importFromNewModal=true" v-if="!isHQUser"><i class="mdi mdi-plus"></i>New</b-button>
                  <b-button variant="primary mr-1" v-b-modal.modal-export><i class="mdi mdi-file-export"></i>Export</b-button>
                </template>                
              </span>
            </div>
            <div id="overflow_nav_buttons" v-show="showNavButtons">
              <span id="left_b" class="ovf_nav_btn_l" @click="scrollXPage('#table',0)">
                <i class="mdi mdi-chevron-double-left"></i>
              </span>
              <span id="right_b" class="ovf_nav_btn_r" @click="scrollXPage('#table',1)">
                <i class="mdi mdi-chevron-double-right"></i>
              </span>
            </div>
            <b-table v-resize="toogleNavButtons"
              id="table" 
              striped 
              hover 
              responsive 
              :per-page="perPage"
              :current-page="1"
              :items="items" 
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              primary-key=""
              no-local-sorting
              no-provider-paging
            >
              <!-- Date Input -->
              <template v-slot:cell(description)="data" lang="html" >
                <b-button class="p-1 m-auto" style="min-width: 30px;" size="sm" variant="primary" title="Description"  @click='openDescriptionModal(data.item)'>
                  <i class="mdi mdi-message-reply-text"></i>
                </b-button>
              </template>
              <template v-slot:cell(dateStart)="data" lang="html">
                <b-row v-if="!isHQUser && data.item.active">
                  <div class="datepicker-container">
                    <datepicker onclick="adjustPositionDate(this)" class="datepicker-input col-lg-6" :format="customFormatter(data.item.dateStart)" v-on:input="checkDateNew(data.item, data.item.dateStart, data.item.dateEnd)" :disabled-dates="disabledStartDates"  placeholder="date to" v-model="data.item.dateStart" ></datepicker>
                    <vue-timepicker onclick="adjustPositionTime(this)" class="timepicker-container col-lg-6" v-on:change="inputHandler($event,  data.item, true)"  :hour-range="enabledCurHoursEdit(data.item.dateStart)" :minute-range="enabledCurMinutesEdit(data.item.dateStart)" :value="customTimeFormatter(data.item.dateStart)" v-if="data.item.dateStart" hide-clear-button></vue-timepicker>
                    <vue-timepicker onclick="adjustPositionTime(this)" class="modal-timepicker timepicker-container col-lg-4"  placeholder="HH:mm"  v-else disabled hide-clear-button></vue-timepicker>
                  </div>
                </b-row>
                <b-row v-else>
                  <div class="datepicker-container">
                    <datepicker onclick="adjustPositionDate(this)" class="datepicker-input  col-lg-6"  :format="customFormatter(data.item.dateStart)" placeholder="date start" v-model="data.item.dateStart" disabled></datepicker>
                    <vue-timepicker class="timepicker-container  col-lg-6"  :placeholder="customTimeFormatter(data.item.dateStart)"   disabled hide-clear-button></vue-timepicker>
                  </div>
                </b-row>
              </template>
              <template v-slot:cell(dateEnd)="data" lang="html">
                <b-row v-if="!isHQUser && data.item.active">
                  <div class="datepicker-container">
                    <datepicker onclick="adjustPositionDate(this)" class="datepicker-input col-lg-6" :format="customFormatter(data.item.dateEnd)" placeholder="date end" v-model="data.item.dateEnd"  v-on:input="checkDateEnd(data.item, data.item.dateEnd)" :disabled-dates="disabledEndDatesGrid(data.item.dateStart)"></datepicker>
                    <vue-timepicker onclick="adjustPositionTime(this)" class="timepicker-container col-lg-4" v-on:change="inputHandler($event, data.item, false)" :value="customTimeFormatter(data.item.dateEnd)" v-if="data.item.dateEnd" hide-clear-button></vue-timepicker>
                    <vue-timepicker onclick="adjustPositionTime(this)" class="modal-timepicker timepicker-container col-lg-4"  placeholder="HH:mm"  v-else disabled hide-clear-button></vue-timepicker>
                  </div>
                </b-row>
                <b-row v-else>
                  <div class="datepicker-container">
                    <datepicker  onclick="adjustPositionDate(this)" class="datepicker-input col-lg-6" :format="customFormatter(data.item.dateEnd)" placeholder="date end" v-model="data.item.dateEnd" disabled></datepicker>
                    <vue-timepicker class="timepicker-container col-lg-4"  :placeholder="customTimeFormatter(data.item.dateStart)"  disabled hide-clear-button></vue-timepicker>
                  </div>
                </b-row>
              </template>
              <template v-slot:cell(discPerc)="data" lang="html">
                <input v-if="!isHQUser && data.item.active && !data.item.discTot" @keypress="isNumber($event)"  v-on:input="checkMax(data.item, false)" type="number" min="0" class="disc-input" v-model="data.item.discPerc" placeholder="---"/>
                <input v-else="!isHQUser" type="text" class="disc-input" v-model="data.item.discPerc" placeholder="---" disabled/>
              </template>
              <template v-slot:cell(discTot)="data" lang="html">
                <input v-if="!isHQUser && data.item.active && !data.item.discPerc" @keypress="isNumber($event)"  type="number" class="disc-input disc-input-large" v-model="data.item.discTot" placeholder="---"/>
                <input v-else type="text" class="disc-input disc-input-large" v-model="data.item.discTot" placeholder="---" disabled/>
              </template>
              <template v-slot:cell(discOpt)="data" lang="html">
                <input v-if="!isHQUser && data.item.active" @keypress="isNumber($event)"  v-on:input="checkMax(data.item, true)"  min="0"   type="number" class="disc-input" v-model="data.item.discOpt" placeholder="---"/>
                <input v-else type="text" class="disc-input" v-model="data.item.discOpt" placeholder="---" disabled/>
              </template>
              <template v-slot:cell(campaignType)="data" lang="html">
                <b-select v-if="!isHQUser && data.item.active" class="col-lg-10" v-model="data.item.campaignType">
                          <b-form-select-option :value="null"></b-form-select-option>
                          <b-form-select-option :value="campaignType" v-for="(campaignType,index) in campaignTypeList">{{campaignType}}</b-form-select-option>
                </b-select>
                <b-select v-else class="col-lg-10" v-model="data.item.campaignType" disabled  >
                          <b-form-select-option :value="data.item.campaignType">{{data.item.campaignType}}</b-form-select-option>
                    </b-select>    
              </template>
              
              <template v-slot:cell(active)="data" lang="html">
                 <b-row v-if="!isHQUser">
                  <b-button v-if="!data.item.active" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover title="Activate" @click="toggleElementStatus(data.item,true)">
                    <i class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                  <b-button v-else="data.item.active" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover  title="Deactivate" @click="toggleElementStatus(data.item,false)">
                      <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                </b-row>
                <b-row v-else>
                  <b-button v-if="!data.item.active" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover title="Activate" disabled>
                    <i class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                  <b-button v-else="data.item.active" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover  title="Deactivate" disabled>
                      <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                </b-row>
              </template>
              <template v-slot:cell(modelList)="data" lang="html">
                 <b-row>
                  <h4 class="panel-title" style="margin:auto;">                 
                    <b-button class="col-lg-5 p-1 m-auto" style="min-width: 2.875rem;" size="sm" variant="primary" title="model List" v-b-modal.modal-edit @click="importFromNewModal=false; findCampaignById(data.item.id)">
                      <i class="mdi mdi-pencil"></i>
                    </b-button>
                  </h4>
                </b-row>
              </template>
              <template v-slot:cell(save)="data" lang="html">
                 <b-row>
                  <h4 class="panel-title" style="margin:auto;">                 
                    <b-button class="col-lg-5 p-1 m-auto" style="min-width: 2.875rem;" size="sm" variant="primary" title="update"  @click="saveCurItem(data.item, false)" v-if="data.item.active && data.item.description && !isHQUser && data.item.dateEnd && atLastOneIsTrue(data.item.discPerc, data.item.discTot, data.item.discOpt)">
                      <i class="mdi mdi-content-save"></i>
                    </b-button>
                    <b-button class="col-lg-5 p-1 m-auto" style="min-width: 2.875rem;" size="sm" variant="primary" title="update" v-else disabled>
                      <i class="mdi mdi-content-save"></i>
                    </b-button>
                  </h4>
                </b-row>
              </template>
              <template v-slot:cell(lastUpdate)="data" lang="html">
                {{customFormatter(data.item.lastUpdate, data.item)}}
              </template>
            </b-table>
            <!-- Modal New -->
            <b-modal id="modal-new" title="New" size="lg" header-bg-variant="primary" header-text-variant="light" centered  @close="closeModalNew()" @hide="closeModalNew()">
              <b-container fluid>
                  <b-row class="m-0">
                    <div class="col-lg-2">Description*:</div><input type="text" class="col-lg-10" placeholder="Description" v-model="newItem.description"/>
                  </b-row>
                  <hr>
                   <b-row class="m-0">
                    <div class="col-lg-2">Disc. %:</div><input id="newItemPerc" @keypress="isNumber($event)"  min="0"  type="number" class="col-lg-2" placeholder="Disc. %" v-model.number="newItem.modelDiscountPerc" />
                    <div class="col-lg-2">Disc. Tot:</div><input id="newItemValue" @keypress="isNumber($event)"  type="number" class="col-lg-2" placeholder="Disc. Tot" v-model.number="newItem.modelDiscountValue"/>
                    <div class="col-lg-2">Disc. Opt %:</div><input   @keypress="isNumber($event)" type="number" min="0"  v-on:input="checkMaxInsert(newItem.optDiscountPerc)"  class="col-lg-2" placeholder="Disc. Opt %:" v-model.number="newItem.optDiscountPerc"/>
                  </b-row>
                  <br>
                  <b-row class="m-0">
                    <b-col class="col-lg-2">Market*:</b-col>
                    <b-select class="col-lg-2" v-model="newItem.country" id="newCountry">
                          <b-form-select-option :value="{}">---</b-form-select-option>
                          <b-form-select-option :value="country" v-for="(country,index) in countryList">{{country.description}}</b-form-select-option>
                    </b-select>
                    <b-col class="col-lg-2">Time Zone*:</b-col>
                    <b-select class="col-lg-2" v-model="newItem.timeZone" id="newTimeZone">
                      <b-form-select-option :value="null">---</b-form-select-option>
                      <b-form-select-option :value="timeZone" v-for="(timeZone,index) in getTzFromIsoCode2" v-if="newItem.country.isoCode2">{{timeZone}}</b-form-select-option>
                    </b-select>
                    <b-col class="col-lg-2">Campaign Type:</b-col>
                    <b-select class="col-lg-2" v-model="newItem.campaignType">
                          <b-form-select-option :value="null"></b-form-select-option>
                          <b-form-select-option :value="campaignType" v-for="(campaignType,index) in campaignTypeList">{{campaignType}}</b-form-select-option>
                </b-select>               
                  </b-row>
                  <hr>
                  <b-row class="just-sb">
                    <div class="col-lg-6 row datepicker-row">
                      <div class="col-lg-2 label-column">From*:</div>
                      <div class="datepicker-container col-lg-10 row">
                        <datepicker class="datepicker-input col-lg-8" :format="customFormatter" placeholder="date from" :disabled-dates="disabledStartDates" v-model="newItem.dateTimeStartUTC"></datepicker>
                        <vue-timepicker onclick="adjustPositionTime(this)" class="modal-timepicker timepicker-container col-lg-4" v-on:change="inputHandlerNew($event, newItem, true)"  :hour-range="enabledStartHoursNew" :minute-range="enabledStartMinutesNew" :value="customTimeFormatter(newItem.dateTimeStartUTC)" v-if="newItem.dateTimeStartUTC" hide-clear-button></vue-timepicker>
                        <vue-timepicker onclick="adjustPositionTime(this)" class="modal-timepicker timepicker-container col-lg-4"  placeholder="HH:mm"  v-else disabled hide-clear-button></vue-timepicker>
                      </div>
                    </div>
                    <div class="col-lg-6 row datepicker-row">
                      <div class="col-lg-2 label-column">To*:</div>
                      <div class="datepicker-container col-lg-10 row" v-if="newItem.dateTimeStartUTC">
                        <datepicker  class="datepicker-input col-lg-8" :format="customFormatter"  placeholder="date to" v-model="newItem.dateTimeEndUTC" :disabled-dates="disabledEndDates()"></datepicker>
                        <vue-timepicker onclick="adjustPositionTime(this)" class="modal-timepicker timepicker-container  col-lg-4" v-on:change="inputHandlerNew($event, newItem, false)"  :value="customTimeFormatter(newItem.dateTimeEndUTC)"  v-if="newItem.dateTimeEndUTC"   hide-clear-button></vue-timepicker>
                        <vue-timepicker onclick="adjustPositionTime(this)" class="modal-timepicker timepicker-container col-lg-4"  placeholder="HH:mm"  v-else disabled hide-clear-button></vue-timepicker>
                      </div>
                      <div class="datepicker-container col-lg-10 row" v-else>
                        <datepicker  class="datepicker-input col-lg-8"  :format="customFormatter" placeholder="date to" v-model="newItem.dateTimeEndUTC" disabled></datepicker>
                        <vue-timepicker onclick="adjustPositionTime(this)" class="modal-timepicker timepicker-container  col-lg-4"  placeholder="HH:mm"  hide-clear-button disabled></vue-timepicker>
                      </div>
                    </div>
                  </b-row>  
                  <br><br>     
                  <b-table 
                    id="tableModel" 
                    striped 
                    hover 
                    responsive 
                    :items="itemsModel" 
                    :fields="visibleFieldModels"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    primary-key=""
                    no-local-sorting
                    no-provider-paging
                    sort-icon-left
                  >
                  <template v-slot:cell(model)="data" lang="html">
                    <b-row v-if="data.item && data.item.statusExcel">
                      {{data.item.model}}
                    </b-row>
                    <b-row v-else-if="data.item && !data.item.statusExcel" style="color: red;">
                      {{data.item.model}}
                    </b-row>
                  </template>   
                  <template v-slot:cell(remove)="data" lang="html">
                    <b-row>
                      <h4 class="panel-title" style="margin:auto;">                 
                        <b-button class="col-lg-3 p-1 m-auto" style="min-width: 30px;" size="sm" variant="danger" @click="deleteModel(data.item,true)">
                          <i class="mdi mdi-delete"></i>
                        </b-button>
                      </h4>
                    </b-row>
                  </template>  
                  <template v-slot:cell(detail)="data" lang="html">
                   <!-- -->
                  </template>  
                  <template v-slot:custom-foot>
                    <tr>
                      <td colspan='2'>
                        <b-select class="col-lg-5" v-model="selectedNewModel"  id="selectedModelMN">
                          <b-form-select-option :value="null">---</b-form-select-option>
                          <template v-for="models in newItem.country.modelGroupItemList"  v-if="newItem.country && newItem.country.modelGroupItemList">
                            <optgroup :label="models.label">
                                <b-form-select-option v-for="(model,index) in models.items" :key="index" :value="model">{{model.solLabel}}</b-form-select-option>
                              </optgroup>
                          </template>
                        </b-select>  
                      </td>
                      <td>
                        <b-button class="col-lg-3 p-1 m-auto" id="addModelBtn" size="sm" variant="primary" title="add model"  @click='addModel(true)'>
                          <i class="mdi mdi-plus"></i>ADD
                        </b-button>
                      </td>
                    </tr>
                  </template>
                </b-table>
                <p style="color:red;text-align: center;">Warning: red text indicates a model not active for SOL now</p>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Cancel
                  </b-button>
                  <b-button v-if="!showSaveButton(newItem) || (!atLastOneIsTrue(newItem.modelDiscountPerc,newItem.modelDiscountValue,newItem.optDiscountPerc))" variant="primary" disabled>
                    Save
                  </b-button>
                  <b-button v-else variant="primary" @click="createItem()">
                    Save
                  </b-button>
                  <b-button variant="primary mr-1" v-if="newItem.country && newItem.country.id" v-b-modal.modal-import><i class="mdi mdi-file-Import"></i>Import</b-button>
                  <b-button variant="primary mr-1" v-else disabled><i class="mdi mdi-file-export"></i>Import</b-button>
                </fragment>
              </template>
            </b-modal>
            <!-- Modal Edit -->
            <b-modal id="modal-edit" title="Edit" size="lg" v-if="curItem" header-bg-variant="primary" header-text-variant="light" centered @close="closeModalEdit()" @hide="closeModalEdit()">
              <b-container fluid>
                  <b-row class="m-0">
                    <div class="col-lg-2">Description:</div><input type="text" class="col-lg-10" placeholder="Description" v-model="curItem.description" disabled/>
                  </b-row>
                  <hr>
                  <b-row class="m-0">
                    <div class="col-lg-2">Disc. %*:</div><input type="text" class="col-lg-2" placeholder="Disc. %" v-model="curItem.discPerc" disabled/>
                    <div class="col-lg-2">Disc. Tot*:</div><input type="text" class="col-lg-2" placeholder="Disc. Tot" v-model="curItem.discTot" disabled/>
                    <div class="col-lg-2">Disc. Opt %*:</div><input type="text" class="col-lg-2" placeholder="Disc. Opt %:" v-model="curItem.discOpt" disabled/>
                  </b-row>
                  <br>
                  <b-row class="m-0">
                     <b-col class="col-lg-2">Market:</b-col>
                      <b-select class="col-lg-2" v-model="curItem.idCountry" id="editCountry " disabled>
                            <b-form-select-option selected :value="country.id" v-for="(country,index) in countryList.filter(country => country.id == curItem.idCountry)">{{country.description}}</b-form-select-option>
                      </b-select>
                      <div class="col-lg-2">TimeZone*:</div><input class="col-lg-2" v-model.number="curItem.timeZone" disabled />
                      <div class="col-lg-2">Campaign Type:</div><input class="col-lg-2" v-model.number="curItem.campaignType" disabled />                              
                  </b-row>
                  <hr>
                  <b-row class="just-sb">
                    <div class="col-lg-6 row datepicker-row">
                      <div class="col-lg-2 label-column">From*:</div>
                      <div class="datepicker-container datepicker-container-disabled col-lg-10 row">
                          <datepicker class="datepicker-input col-lg-2" :format="customFormatter(curItem.dateStart)" placeholder="date from" v-model="curItem.dateStart" disabled></datepicker>
                          <vue-timepicker class="timepicker-container col-lg-2" :value="customTimeFormatter(curItem.dateStart)"  hide-clear-button disabled></vue-timepicker>
                      </div>
                    </div>
                    <div class="col-lg-6 row datepicker-row">
                      <div class="col-lg-2 label-column">To*:</div>
                      <div class="datepicker-container datepicker-container-disabled col-lg-10 row">
                        <datepicker  class="datepicker-input col-lg-2" :format="customFormatter"  placeholder="date to" v-model="curItem.dateEnd" disabled></datepicker>
                        <vue-timepicker class="timepicker-container col-lg-2" :value="customTimeFormatter(curItem.dateEnd)"  hide-clear-button disabled></vue-timepicker>
                      </div>
                    </div>
                  </b-row>      
                  <br><br> 
                  <b-table 
                    id="tableModel" 
                    striped 
                    hover 
                    responsive 
                    :items="itemsModel" 
                    :fields="visibleFieldModels"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    primary-key=""
                    no-local-sorting
                    no-provider-paging
                    sort-icon-left
                    v-if="curItem.active && !isHQUser"
                  >
                  <template v-slot:cell(model)="data" lang="html">
                    <b-row v-if="data.item && data.item.statusExcel">
                        {{data.item.model}}
                    </b-row>
                     <b-row v-else-if="data.item && !data.item.statusExcel" style="color: red;">
                      {{data.item.model}}
                    </b-row>
                  </template>   
                  <template v-slot:cell(remove)="data" lang="html">
                    <b-row>
                      <h4 class="panel-title" style="margin:auto;">                 
                        <b-button class="col-lg-3 p-1 m-auto" style="min-width: 30px;" size="sm" variant="danger" @click="deleteModel(data.item, false)">
                          <i class="mdi mdi-delete"></i>
                        </b-button>
                      </h4>
                    </b-row>
                  </template>  
                  <template v-slot:cell(detail)="data" lang="html">
                   <b-row>
                      <b-button class="col-lg-3 p-1 m-auto" style="min-width: 30px;" size="sm" variant="primary" title="price configuration"  @click='goToPriceConf(data.item.vetele)'>
                        <i class="mdi mdi-link-variant"></i>
                      </b-button>
                    </b-row>
                  </template>  
                  <template v-slot:custom-foot>
                    <tr>
                      <td colspan='2'>
                        <b-select class="col-lg-5" v-model="selectedEditModel"  id="selectedEditModelId">
                          <b-form-select-option :value="null">---</b-form-select-option>
                          <template v-for="models in countryList.find(country => country.id == curItem.idCountry).modelGroupItemList">
                            <optgroup :label="models.label">
                                <b-form-select-option v-for="(model,index) in models.items" :key="index" :value="model">{{model.solLabel}}</b-form-select-option>
                              </optgroup>
                          </template>
                        </b-select>  
                      </td>
                      <td>
                        <b-button class="col-lg-3 p-1 m-auto" id="addModelBtn" size="sm" variant="primary" title="add model"  @click='addModel(false)' v-if="curItem">
                          <i class="mdi mdi-plus"></i>ADD
                        </b-button>
                      </td>
                    </tr>
                  </template>
                </b-table>
                <b-table v-else
                 id="tableModel" 
                  striped 
                  hover 
                  responsive 
                  :items="itemsModel" 
                  :fields="visibleFieldModels"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  primary-key=""
                  no-local-sorting
                  no-provider-paging
                  sort-icon-left
                >
                 <template v-slot:cell(remove)="data" lang="html">
                    <b-row>
                      <h4 class="panel-title" style="margin:auto;">                 
                        <b-button class="col-lg-3 p-1 m-auto" style="min-width: 30px;" size="sm" variant="danger" disabled>
                          <i class="mdi mdi-delete"></i>
                        </b-button>
                      </h4>
                    </b-row>
                  </template>  
                  <template v-slot:cell(detail)="data" lang="html">
                   <b-row>
                      <b-button class="col-lg-3 p-1 m-auto" style="min-width: 30px;" size="sm" variant="primary" title="price configuration"  @click='goToPriceConf(data.item.vetele)'>
                        <i class="mdi mdi-link-variant"></i>
                      </b-button>
                    </b-row>
                  </template>  
                 <template v-slot:custom-foot>
                    <tr>
                     <td colspan='2'>
                        <b-select class="col-lg-5" v-model="selectedEditModel" disabled id="selectedEditModelId">
                          <b-form-select-option :value="null">---</b-form-select-option>
                        </b-select>  
                      </td>
                      <td>
                        <b-button class="col-lg-3 p-1 m-auto" id="addModelBtn" size="sm" variant="primary" title="add model"  disabled>
                          <i class="mdi mdi-plus"></i>ADD
                        </b-button>
                      </td>
                    </tr>
                  </template>
                </b-table>
                <p style="color:red;text-align: center;">Warning: red text indicates a model not active for SOL now</p>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="primary mr-1" v-if="isFromPriceConf" @click="back()"><i class="mdi mdi-arrow-left"></i>Back To Price Configurator</b-button>
                  <b-button v-else variant="secondary" @click="cancel()">
                    Cancel
                  </b-button>
                  <b-button v-if="!showEditButton(curItem)" variant="primary" disabled>
                    Save
                  </b-button>
                  <b-button v-else variant="primary" @click="saveCurItem(curItem, true)">
                    Save
                  </b-button>
                  <b-button variant="primary mr-1" v-if="curItem.idCountry && curItem.active && !isHQUser" v-b-modal.modal-import><i class="mdi mdi-file-Import"></i>Import</b-button>
                  <b-button variant="primary mr-1" v-else disabled><i class="mdi mdi-file-export"></i>Import</b-button>
                </fragment>
              </template>
            </b-modal>
            <b-modal id="modal-description" title="Description" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <textarea class="col-lg-12" v-model="curItemTemp.description" v-if="curItemTemp.active && !isHQUser"></textarea>
                  <textarea class="col-lg-12" v-model="curItemTemp.description" v-else disabled></textarea>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="closeModelDescription(curItemTemp)">
                    Cancel
                  </b-button>
                  <b-button variant="primary" @click="closeModelDescription(null)">
                    Continue
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            <b-modal id="modal-export" title="Export"  size="sm" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-sm-4 pt-2">Scope: </div>
                  <b-form-select class="col-sm-8" v-model="selectedScopeExport" :options="options"></b-form-select>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Cancel
                  </b-button>
                  <b-button variant="primary" @click="exportXlxs(false)">
                    Export xlsx
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            <b-modal id="modal-import" title="Upload File"  size="lg" header-bg-variant="primary" header-text-variant="light" centered  @close="closeModal()" @hide="closeModal()">
              <div class='modal-body'>
                <form method='post' action='' enctype='multipart/form-data'>
                  <div class='custom-file mb-3'>
                    <input type='file' class="col-lg-8" id='file-input' name='filename' @change="changeFileName()">
                    <label class='custom-file-label' for='file-input'>{{fileName}}</label>
                  </div>
                  <br>
                </form>
              </div>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="primary mr-1" @click="exportXlxs(true)"><i class="mdi mdi-file-export"></i>
                    Template
                  </b-button>
                  <b-button variant="secondary" @click="cancel()">
                    Cancel
                  </b-button>
                  <b-button v-if="!fileName" variant="primary" disabled>
                    Upload
                  </b-button>
                  <b-button v-else variant="primary" @click="uploadFile()">
                    Upload
                  </b-button>
                </fragment>
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style>

tbody[role=rowgroup] >  tr[role=row] >  td[role=cell] > .row > .datepicker-container { position: inherit;  white-space: initial;}
tbody[role=rowgroup] >  tr[role=row] >  td[role=cell] > .row > .datepicker-container > .vdp-datepicker { position: inherit;  white-space: unset;}
tbody[role=rowgroup] >  tr[role=row] >  td[role=cell] > .row > .datepicker-container > .vdp-datepicker > .vdp-datepicker__calendar { position: absolute;  white-space: unset;}
tbody[role=rowgroup] >  tr[role=row] >  td[role=cell] > .row > .datepicker-container  > .timepicker-container > .display-time {border: white; color: black;};
tbody[role=rowgroup] >  tr[role=row] >  td[role=cell] > .row > .datepicker-container_grid  > .timepicker-container > .display-time {border: white; color: black;};
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
import mixin from '../../mixin/mixin.js'
import Datepicker from 'vuejs-datepicker';
const FileDownload = require('js-file-download');
const MomentWithTimezone = require('moment-timezone');
import moment from 'moment';
import VueTimepicker from 'vue2-timepicker/src'

export default {
  name: 'sol_campaign',
  mixins: [mixin],
  methods: {
    closeModelDescription(item){
      if(item)
        item.description = this.oldDescription;
      this.$bvModal.hide('modal-description');
    },
    inputHandlerNew(eventData, item, isStart) {
      var time = eventData.data;
      if(time.HH && time.mm){
        var date = isStart ? item.dateTimeStartUTC : item.dateTimeEndUTC;
        date = moment(date);
        date.hour(time.HH);
        date.minutes(time.mm);

        if(isStart){
          item.dateTimeStartUTC = new Date(date);
        }else{
          item.dateTimeEndUTC = new Date(date);
        };
      }
    },
    inputHandler(eventData, item, isStart){
      var time = eventData.data;
      if(time.HH && time.mm){
        var date = isStart ? item.dateStart : item.dateEnd;
        date = moment(date);
        date.hour(time.HH);
        date.minutes(time.mm);

        if(isStart){
          item.dateStart = new Date(date);
        }else{
          item.dateEnd = new Date(date);
        };
      }
    },
     goToPriceConf(vetele, idCountry){
      this.setSpinnerStatus(true);
      this.axios
      .post("/ccb/auth/fe/commercialModel/checkIfExistVeteleActive/"+vetele, null, this.authHeader)
      .then(response => {
        if(response.status == 200){
          if(this.$route.params.from == 'price_conf') {
            this.setComeFromSolCampaign(true);
            this.setStartFromSolCampaign(false);
          } else {
            this.setComeFromSolCampaign(false);
             this.setStartFromSolCampaign(true);
             if(this.selectedCountry)
              this.filterObj.idCountry = this.selectedCountry.id;
              this.setDate();      
             this.setOriginalCampaignObject({filterObj : this.filterObj, from: 'sol_campaign'})
          }
         
          this.$router.push({name: "price_configurator", params: { vetele : vetele, idCountry: this.curItem.idCountry, idCampaign : this.curItem.id, from: 'sol_campaign'}});
        }       
      }).catch(error => {
        this.$bvModal.msgBoxOk("Model not active", {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
      .finally(e=>{
        this.setSpinnerStatus(false);
      })
    },
    customTimeFormatter(date){
      if(date != null){
        return moment(date).format('HH:mm');
      } else
        return null;
    },
    customFormatter(date) {
      if(date != null){
        return moment(date).format('DD/MM/YY');
      }
    }, 
    checkMax(item, opt){
      var data = opt ? item.discOpt : item.discPerc;
      if(data && parseInt(data) > 100){
        if(opt){
          item.discOpt = 100;
        }else{
          item.discPerc = 100;
        }
      };
    },
     checkMaxInsert(data){
      if(data && parseInt(data) > 100){
          data = 100;
      }
    },
    checkDateEnd(item, dateEnd){
      if(dateEnd){
          var end = new Date(dateEnd);
          var dateWithTime = moment(end);
          if(dateWithTime){
            dateWithTime.hour("00");
            dateWithTime.minutes("00");
            item.dateEnd = dateWithTime._d;
          }
      }
    },
    checkDateNew(item, dateStart, dateEnd){
      var start = new Date(dateStart);
      var end = new Date(dateEnd);
      if(start){
        var dateWithTime = moment(start);
        if(dateWithTime){
          dateWithTime.hour("00");
          dateWithTime.minutes("00");
          item.dateStart = dateWithTime._d;
        }
      }
      if((start.getTime() > end.getTime()) || (start.toDateString() == end.toDateString())){
        var dateWithTime = moment(end);
        if(dateWithTime){
          dateWithTime.hour("00");
          dateWithTime.minutes("00");
          item.dateEnd = dateWithTime._d;
          setTimeout(function () {
            item.dateEnd = null;
          }, 250);
        }
    } 
    },
    openDescriptionModal(data){
      this.oldDescription = data.description;
      this.curItemTemp = data;
      this.$bvModal.show('modal-description');
    },
    closeModalNew(){
      this.selectedNewModel = null;
      this.itemsModel = [];
      this.newItem = {description : null, active: true, dateTimeStartUTC: null, dateTimeEndUTC: null, country: {}, modelDiscountPerc: null, modelDiscountValue: null, optDiscountPerc: null, solCampaignModel : [], timeZone : null, active: true};
    },
    closeModalEdit(){
       this.selectedEditModel = null;
      this.curItem = null;
      this.itemsModel = [];
      this.refreshTable();
    },
    closeModal(){
      this.fileName = null;
    },
    uploadFile(isNew){
      let file=document.querySelector('#file-input').files[0];   
      let formData = new FormData();
      formData.append("file", file );
      formData.append("filename", file.name);
      if(this.getCurUser.userAliasFromModis)
        formData.append("curUserName", this.getCurUser.userAliasFromModis);
      else
        formData.append("curUserName", this.getCurUser.username);
      if(!this.importFromNewModal){
        formData.append("idCampaign", this.curItem.id);
        formData.append("idCountry", this.curItem.idCountry);
      }else{
        formData.append("idCountry", this.newItem.country.id);
      }
      formData.append("exampleObj", JSON.stringify(this.filterObj));
      this.setSpinnerStatus(true);
      this.axios
      .post("/ccb/auth/fe/solCampaign/fromXlsx", formData ,  this.authHeader)
      .then((response) => {
        var result="";

        if(this.importFromNewModal)
          this.setItemsModel(response.data.model, this.newItem.country.id, true);
        else
          this.setItemsModel(response.data.model, this.curItem.idCountry, false);

        response.data.msg.forEach(element => {
          result+=element+" \n \n";
        });
          window.datas = result;         
          const messageNodes = this.$createElement(
              'pre',
              {
                domProps: { innerHTML: result }
              }
            )
          this.$bvModal.msgBoxOk([messageNodes], {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true,
              size: 'xl'
            }).then(value => {
              this.refreshTable();
            })          
        })
       .catch(error => {
         this.$bvModal.msgBoxOk(error.message, {
           okVariant: 'danger',
           hideHeaderClose: false,
           centered: true
         })
       }).finally(e=>{
         this.setSpinnerStatus(false);
         this.$bvModal.hide('modal-import');
       })
    },
     changeFileName(){
      this.setSpinnerStatus(true);
      if(document.querySelector('#file-input').files[0] && document.querySelector('#file-input').files[0].name) {
        this.fileName = document.querySelector('#file-input').files[0].name;
      } else {
        this.fileName = '';
      }
      this.setSpinnerStatus(false);
    },
    toggleElementStatus(item, visibilityValue) {
      var stato = (!visibilityValue) ? 'deactivate' : 'activate'
      this.$bvModal.msgBoxConfirm('Do you want to '+stato+' Campaign '+item.id+' ?', {
        title: 'Change Status',
        okVariant: 'danger',
        okTitle: 'Continue',
        cancelTitle: 'Cancel',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          this.active(visibilityValue, item.id);         
        }
      })
    },
   deleteModel(model_, isNew){
      this.itemsModel = this.itemsModel.filter(model => model.vetele != model_.vetele);
      if(isNew){
        this.newItem.solCampaignModel = this.newItem.solCampaignModel.filter(solCam => solCam.model.vetele !=  model_.vetele);
      }else{
        this.curItem.solCampaignModel = this.curItem.solCampaignModel.filter(solCam => solCam.vetele !=  model_.vetele);
      }
   },
   addModel(isNew){
     var modelSelected = isNew ? this.selectedNewModel: this.selectedEditModel;
     this.setSpinnerStatus(true);
     if(modelSelected){
      var exist = null;
      if(this.itemsModel && this.itemsModel.length > 0)
        var exist = this.itemsModel.find(model => model.vetele == modelSelected.value);
      if(!exist){
        this.axios
        .get('/ccb/auth/fe/solModel/checkSol/'+modelSelected.value, this.authHeader)
        .then(response => {
          if(response.status == 200){
            var statusCode = true;
            if(response.data == 0){
              statusCode = false;
            }
            if(isNew){
              this.newItem.solCampaignModel.push({ model : { vetele : modelSelected.value, statusExcel : statusCode}});
            } else {
              this.curItem.solCampaignModel.push({ vetele : modelSelected.value, statusExcel : statusCode});
            }
            this.itemsModel.push({vetele: modelSelected.value, model: modelSelected.solLabel, statusExcel: statusCode});
          } 
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
      }else{
        this.$bvModal.msgBoxConfirm('Model already selected', {
          title: 'Warning',
          okVariant: 'danger',
          cancelTitle: 'Cancel',
          hideHeaderClose: false,
          centered: true
        })
      }
      if(isNew){
        this.selectedNewModel = null;
      } else {
        this.selectedEditModel = null;
      }
     }
     this.setSpinnerStatus(false);
   },
   emptydateTo(){
      this.filterObj.dateEnd = null;
    },
    emptydateFrom(){
      this.filterObj.dateStart = null;
    },
    emptydateToInsert(){
      this.newItem.dateTimeEndUTC = null;
    },
    emptydateFromInsert(){
      this.newItem.dateTimeEndUTC = null;
      this.newItem.dateTimeStartUTC = null;
    },
    saveCurItem(curItem, editMode) {
      var intLabObj = curItem
      intLabObj.lastUpdate = new Date();
      this.setSpinnerStatus(true);
      var urlBase = '/ccb/auth/fe/solCampaign/' + intLabObj.id + "/" +  editMode + "/" + (this.getCurUser.userAliasFromModis ? this.getCurUser.userAliasFromModis : this.getCurUser.username); 
      this.axios
      .put(urlBase, intLabObj, this.authHeader)
      .then(response => {
        if(response.status == 200) {            
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            if (this.$route.params.filterObj) {
              if(this.$route.params.from == 'price_conf'){
                this.isFromPriceConf = true;
                this.findCampaignById(this.$route.params.idCampaign);
                this.filterObj.dateEnd = this.$route.params.filterObj.dateEnd;
              }
              
            } else {
              this.refreshTable();
            }
            
          })
        }    
      })
      .catch(error => {
      this.$bvModal.msgBoxOk(error.message, {
        okVariant: 'danger',
        hideHeaderClose: false,
        centered: true
      })
      })
      .finally(e=>{        
        this.setSpinnerStatus(false);
      })
    },   
    active(active, id) {
      this.setSpinnerStatus(true);
      var urlBase = '/ccb/auth/fe/solCampaign/active/' + id + "/" +  active + "/" + (this.getCurUser.userAliasFromModis ? this.getCurUser.userAliasFromModis : this.getCurUser.username); 
      this.axios
      .put(urlBase, null, this.authHeader)
      .then(response => {
        if(response.status == 200) {            
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            this.refreshTable();
          })
        }    
      })
      .catch(error => {
      this.$bvModal.msgBoxOk(error.message, {
        okVariant: 'danger',
        hideHeaderClose: false,
        centered: true
      })
      })
      .finally(e=>{
        this.refreshTable();
        this.setSpinnerStatus(false);
      })
    },   
    exportXlxs(isOnlyTemplate){
      this.setSpinnerStatus(true);
      let params = {
        scope: this.selectedScopeExport,
        isOnlyTemplate: isOnlyTemplate
      }
      this.axios
      .post('/ccb/auth/fe/solCampaign/toXlsx', this.filterObj, {
        responseType: 'blob',
        params: params,
        ...this.authHeader})
      .then(response => {
        if(response.status == 200) {            
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true,
          })
          var disposition = response.headers['content-disposition'];
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          var filename = matches[1].replace(/['"]/g, '');
          FileDownload(response.data, filename);
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }).finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-export');
      })
    },
    showSaveButton(item){
      return item.description && item.dateTimeStartUTC && item.dateTimeEndUTC && item.country && item.country.id && item.solCampaignModel && item.solCampaignModel.length > 0 &&  item.timeZone;
    },
    showEditButton(item){
      return item.description && item.dateStart && item.dateEnd && item.idCountry && item.solCampaignModel && item.solCampaignModel.length > 0 && item.active && !this.isHQUser;
    },
    createItem() {
      var date =  new Date();
      var intLabObj = this.newItem;
      intLabObj.solCampaignModel.forEach(model => {
      if(this.getCurUser.userAliasFromModis)
        intLabObj.insertUser = this.getCurUser.userAliasFromModis;
      else
        intLabObj.insertUser = this.getCurUser.username;
      
      model.insertUser = this.getCurUser.username
      model.insertDate = date;
      });
      this.setSpinnerStatus(true);
      if(this.getCurUser.userAliasFromModis)
        intLabObj.insertUser = this.getCurUser.userAliasFromModis;
      else
        intLabObj.insertUser = this.getCurUser.username;
      console.log(intLabObj)
      intLabObj.insertDate = date;
      this.axios
      .post('/ccb/auth/fe/solCampaign', intLabObj, this.authHeader)
        .then(response => {
          window.risposta = response;
          console.log(response)
          if(response.status == 201) {
            this.$bvModal.msgBoxOk('Created!', {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
            .then(value => {
              this.curItem = intLabObj;
              this.findCampaignById(response.data);
              this.$bvModal.hide('modal-new')
            })           
          }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
        .finally(e=>{
          this.setSpinnerStatus(false);
        })         
    },
    setDate(){
      var year = '';
      var month = '';
      var day = '';
  
      if(this.filterObj.dateEnd){
        var date = this.filterObj.dateEnd;
        var day = moment(date,"DD/MM/YYYY").date();
        var year = moment(date,"DD/MM/YYYY").year();
        var month =  moment(date,"DD/MM/YYYY").month(); 
        this.filterObj.dateEnd = new Date(year, month, day, 23, 59, 59, 999);
      }
    },
    search() {
      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
      var params = {
        page: this.currentPage-1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, isHQUser: this.isHQUser
      }

      if(this.selectedCountry)
        this.filterObj.idCountry = this.selectedCountry.id;
      else{
        this.filterObj.idCountry = null;
      }

      if (this.$route.params.filterObj) {
              if(this.$route.params.from == 'price_conf'){
                this.isFromPriceConf = true;
                this.filterObj=this.defaultFilterObj;
                this.filterObj.id = this.$route.params.filterObj.id;
              } else if (this.$route.params.from == 'sol_campaign'){
                this.$route.params.from = null
                this.filterObj.idCountry = this.$route.params.filterObj.idCountry;
                this.filterObj.vetele = this.$route.params.filterObj.vetele;
              }
              
            }else{
              this.setDate();
            }
      
      
      
      this.axios        
        .post('/ccb/auth/fe/solCampaign/allPaged' , this.filterObj, {
          params: params,
          ...this.authHeader}          
        )
        .then(response => {
          this.items = response.data.content;
          this.items.forEach(data => {
            var tz = data.timeZone;
            var dateStart = data.dateStart;
            var dateEnd = data.dateEnd;

            data.dateStart = new Date(MomentWithTimezone.utc(dateStart).tz(tz).format('MM DD YYYY HH:mm'))
            data.dateEnd = new Date( MomentWithTimezone.utc(dateEnd).tz(tz).format('MM DD YYYY HH:mm'));

            
          });
          this.totalRowsResult = response.data.totalElements;
          this.setSpinnerStatus(false);
        });
    },
    findCampaignById(id) {
      this.setSpinnerStatus(true);   
      this.axios
      .get('/ccb/auth/fe/solCampaign/'+id, this.authHeader)
        .then(response => {
          const  result = response.data;
          const  solCampaignModelList = response.data.solCampaignModel;
          this.curItem = result;
          this.itemsModel = [];
          solCampaignModelList.forEach(model => {
            this.itemsModel.push(model);
          });
          var tz = this.curItem.timeZone;
          var dateStart = this.curItem.dateStart;
          var dateEnd = this.curItem.dateEnd;

          this.curItem.dateStart = new Date(MomentWithTimezone.utc(dateStart).tz(tz).format('MM DD YYYY HH:mm'))
          this.curItem.dateEnd = new Date( MomentWithTimezone.utc(dateEnd).tz(tz).format('MM DD YYYY HH:mm'));
          this.$bvModal.show('modal-edit')       
        })
        .finally(() => { 
          this.setSpinnerStatus(false);
          this.$bvModal.show('modal-edit')} );                 
    },
    setItemsModel(solCampaignModel, idCountry, initialize){
      if(solCampaignModel && solCampaignModel.length > 0){
        let countryUser = this.countryList.find(country => country.id == idCountry);
        let listModels =  countryUser.modelGroupItemList;
        if(initialize)
          this.itemsModel = [];
        solCampaignModel.forEach(modelsUser => {
          let modelSelected = listModels.find(model => model.items.find(item => item.value == modelsUser.model));
          if(modelSelected){
            modelSelected =  modelSelected.items.find(value => value.value == modelsUser.model);
            var modelObj = {vetele: modelSelected.value, model: modelSelected.solLabel, statusExcel: modelsUser.statusExcel}
            this.itemsModel.push(modelObj);
            if(initialize)
              this.newItem.solCampaignModel.push({ model : { vetele : modelSelected.value}});
            else
            this.curItem.solCampaignModel.push(modelObj)
          }else if(!modelsUser.statusExcel){
            var modelObj = {vetele: modelsUser.model, model:  modelsUser.model, statusExcel: modelsUser.statusExcel}
            this.itemsModel.push(modelObj);
          }
        });
      }
    },
    getAllModel() {
      this.axios
      .post('/ccb/auth/fe/commercialModel/getModelGroup', this.filterObj.countryList, this.authHeader)
      .then(response => {
        if(response.status == 200) {
          this.selectedModel = response.data;
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
      .finally(e=>{
        this.setSpinnerStatus(false);
      })         
    },
    isNumber(evt = KeyboardEvent) {
      const keysAllowed  = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
      const keyPressed = evt.key;
      
      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
    disabledEndDatesGrid(dateStart){ 
      var dateWithTime = moment(dateStart);
      if(dateWithTime){
        dateWithTime.hour("00");
        dateWithTime.minutes("00");
        var date = moment(dateWithTime).add(1, 'd')._d;
        var disabledEndDates = {to :date};
        return disabledEndDates;
      }
    },
     enabledCurHoursEdit(dateStart){
      if(dateStart){
        var date = new Date(dateStart)
        if(date && date.toDateString() == new Date().toDateString()){
        const currentHour = new Date().getHours();
        return [ [ currentHour, 23 ] ];
      }
      }
     }, 
    enabledCurMinutesEdit(dateStart){  
      if(dateStart){
        var date = new Date(dateStart)
        var hourdate = date.getHours();
        var curHourDate = new Date().getHours();
        if(date.toDateString() == new Date().toDateString() && hourdate == curHourDate){
          const currentMinute = new Date().getMinutes();
          return [ [ currentMinute, 59 ] ];
        }
      }
    },
    disabledEndDates(){ 
      var dateWithTime = moment(this.newItem.dateTimeStartUTC);
      dateWithTime.hour("00");
      dateWithTime.minutes("00");
      var date = moment(dateWithTime).add(1, 'd')._d;
      var disabledEndDates = {to :date};

      return disabledEndDates;
    },
    refreshTable() {
      this.search();
    },
  atLastOneIsTrue(a,b,c){
        if ((a!=null && a > 0) || (b!=null && b > 0) || (c!=null && c > 0))
          return true
        else
          return false;
      },
    ...mapActions([
    'setCurApp',
    'setSpinnerStatus',
    'setLastSearch',
    'setComeFromSolCampaign',
    'setStartFromSolCampaign',
    'setOriginalCampaignObject'
    ]),
     scrollXPage (target, direction) {
      if(direction > 0) 
        this.$el.querySelector(target).parentNode.scrollLeft += this.$el.querySelector(target).clientWidth/4
      else
        this.$el.querySelector(target).parentNode.scrollLeft -= this.$el.querySelector(target).clientWidth/4
    },
    back(){      
      if(this.isFromPriceConf)
          this.$router.push({name: "price_configurator", params: { vetele : this.$route.params.vetele, idCountry: this.$route.params.idCountry, idCampaign : this.$route.params.idCampaign, filterObj: this.$route.params.filterObj, from: 'back_from_sol_campaign'}});
    },
    toogleNavButtons ( width, height ) {
      var overFlowTable = document.getElementById('table')
      if (width < overFlowTable.offsetWidth && (!this.showNavButtons || this.showNavButtons == null)) {
        this.showNavButtons = true
      } else if ((width == overFlowTable.offsetWidth || width > overFlowTable.offsetWidth) && (this.showNavButtons || this.showNavButtons == null)) {
        this.showNavButtons = false
      }
    },
    initialResizeCheck(tableResponsive, milliseconds){
      var ctx = this  
      var resizeCheck = setInterval(function(){
        if(ctx.counter < 3){
          ctx.counter++
          ctx.toogleNavButtons(tableResponsive.offsetWidth, 0)
        } else {
          clearInterval(resizeCheck)
        }
      }, milliseconds)
    }
  },
  props:["selectedCountryParam","veteleParam","idCampaignParam"],
  data () {
    return {
      oldDescription: null,
      importFromNewModal : false,
      curItemTemp: false,
      newItem : {description : null, active: true, dateTimeStartUTC: null, dateTimeEndUTC: null, country: {}, modelDiscountPerc: null, modelDiscountValue: null, optDiscountPerc: null, solCampaignModel : [], timeZone : null, active: true, campaignType: null},
      selectedEditModel: null,
      countryList: [],
      filterObj: {
          vetele: null,
          idCountry: null,
          active: false,
          dateStart: null,
          dateEnd: null,
          countryList: []
        },
      defaultFilterObj: {
          vetele: null,
          idCountry: null,
          active: false,
          dateStart: null,
          dateEnd: null,
          countryList: []
        }, 
      selectedNewModel: null,
      selectedScopeExport: true,
      selectedCountry : null,
      selectedModel : null,
      isHQUser : false,
      urlExport:' ',
      selected: false,
      options: [
        { value: true, text: 'ALL' },
        { value: false, text: 'FILTERED' },
      ],
      totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:15,
      sortBy:'',
      sortDesc: true,
      curItem: null,
      fileName: '',
      isPostPriceConf: false,
      items: [],
      itemsModel: [],
      fieldsModel :  [
        {
          key: 'vetele',
          label: '',
          sortable: false,
          visible : false
        },
        {
          key: 'model',
          label: 'Model',
          sortable: false,
          visible : true
        },
        {
          key: 'remove',
          label: 'Remove',
          sortable: false,
          visible : true
        },
        {
          key: 'detail',
          label: 'Detail',
          sortable: false,
          visible : true
        }
      ],
      fields :  [
        {
          key: 'id',
          label: 'Campaign ID',
          sortable: true,
          visible : true
        },
        {
          key: 'market',
          label: 'Market',
          sortable: true,
          visible : true
        },
        {
          key: 'dateStart',
          label: 'Date Start',
          sortable: true,
          visible : true
        },
        {
          key: 'dateEnd',
          label: 'Date End',
          sortable: true,
          visible : true
        },
        {
          key: 'discPerc',
          label: 'Disc.%',
          sortable: true,
          visible : true
        },
        {
          key: 'discTot',
          label: 'Disc. Tot',
          sortable: true,
          visible : true
        },
        {
          key: 'discOpt',
          label: 'Disc. Opt%',
          sortable: true,
          visible : true
        },
        {
          key: 'description',
          label: 'Desc',
          sortable: true,
          visible : true
        },
        {
          key: 'campaignType',
          label: 'Campaign Type',
          sortable: true,
          visible : true
        },
        
        {
          key: 'lastUpdate',
          label: 'Last Update',
          sortable: true,
          visible : true
        },
        {
          key: 'active',
          label: 'Active',
          sortable: false,
          visible : true
        },
        {
          key: 'save',
          label: 'Save',
          sortable: false,
          visible : true
        },
        {
          key: 'modelList',
          label: 'Model List',
          sortable: false,
          visible : true
        },
        
      ],
      externallyLoaded: false,
      isFromPriceConf: false,
      showNavButtons: null,
      counter: 0,
      campaignTypeList : ['B2B','B2C']
    }
  },
  components: {
  	Datepicker,
    VueTimepicker
  },
  computed: {
    enabledStartHoursNew(){
      if(this.newItem && this.newItem.dateTimeStartUTC && this.newItem.dateTimeStartUTC.toDateString() == new Date().toDateString()){
        const currentHour = new Date().getHours();
        return [ [ currentHour, 23 ] ];
      }
     }, 
    enabledStartMinutesNew(){
      if(this.newItem && this.newItem.dateTimeStartUTC){
        var hourdate = this.newItem.dateTimeStartUTC.getHours();
        var curHourDate = new Date().getHours();
        if(this.newItem.dateTimeStartUTC.toDateString() == new Date().toDateString() && hourdate == curHourDate){
          const currentMinute = new Date().getMinutes();
          return [ [ currentMinute, 59 ] ];
        }
      }
    },   
    getTzFromIsoCode2(){
      if(this.newItem && this.newItem.country && this.newItem.country.isoCode2){
        var tzList = MomentWithTimezone.tz.zonesForCountry(this.newItem.country.isoCode2);
        if(tzList.length == 1) this.newItem.timeZone = tzList[0]; 
        else  this.newItem.timeZone = null;
        return tzList;
      } else  {
        this.newItem.timeZone = null;
        return [];
      }
    },
    getModelList(){
      if(!this.isPostPriceConf && !this.isFromPriceConf){
        this.filterObj.vetele = null;
        if(this.selectedCountry){
          return ((this.selectedCountry && this.selectedCountry.modelGroupItemList) ? this.selectedCountry.modelGroupItemList : [])
        } else{ 
          if(this.isHQUser){
            return this.selectedModel;
          }
        }
      }else{
        if(this.filterObj.vetele){
          if(this.selectedModel){
            var modelFind = this.selectedModel.find(models => models.items.find(model=> model.value == this.filterObj.vetele));
            return new Array(modelFind);
          }
          return new Array(this.filterObj.vetele);
        }
      }
    },
    disabledStartDates(){ 
      var disabledStartDates = {to : null};
      var date = new Date();
      date.setDate(date.getDate() - 1);
      var day = moment(date,"DD/MM/YYYY").date();
      var year = moment(date,"DD/MM/YYYY").year();
      var month =  moment(date,"DD/MM/YYYY").month(); 
      
      disabledStartDates.to = new Date(year, month, day, 23, 59, 59, 999);
      return disabledStartDates;
    },
    visibleFields() {
      return this.fields.filter(field => field.visible)
    },
    visibleFieldModels() {
      return this.fieldsModel.filter(fieldsModel => fieldsModel.visible)
    },
    ...mapGetters([
      'getCurLanguage',
      'getCurUser',
      'authHeader',
      'getComeFromSolCampaign',
      'getStartFromSolCampaign',
      'getOriginalCampaignObject'
    ])
  },
  watch:{
    currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      if(newValue)
        this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    },
    'newItem.modelDiscountValue': function (newVal, oldVal){
      if(newVal){
        document.querySelector('#newItemPerc').disabled = true; 
      }else{
        document.querySelector('#newItemPerc').disabled = false; 
      }
    },
    'newItem.modelDiscountPerc': function (newVal, oldVal){
      if(newVal){
        document.querySelector('#newItemValue').disabled = true; 
        if(newVal > 100){
          this.newItem.modelDiscountPerc = 100;
        }
      }else{
        document.querySelector('#newItemValue').disabled = false; 
      }
    },
    'newItem.optDiscountPerc': function (newVal, oldVal){
      if(newVal){
        if(newVal > 100){
          this.newItem.optDiscountPerc = 100;
        }
      }
    },
    'newItem.country': function (newVal, oldVal){
      this.itemsModel = [];
      this.selectedNewModel = null;
      this.newItem.solCampaignModel = [];
    },
    'newItem.dateTimeStartUTC': function (newVal, oldVal){
      if(newVal){
        if(!oldVal || (oldVal && oldVal.toDateString() != newVal.toDateString())){
          var dateWithTime = moment(newVal);
          dateWithTime.hour("00");
          dateWithTime.minutes("00");
          this.newItem.dateTimeStartUTC = dateWithTime._d;
          if(this.newItem.dateTimeEndUTC){
            if((newVal.getTime() > this.newItem.dateTimeEndUTC.getTime()) || (newVal.toDateString() == this.newItem.dateTimeEndUTC.toDateString())){
              var dateEndWithTime = moment(new Date(this.newItem.dateTimeEndUTC));
              if(dateEndWithTime){
                dateEndWithTime.hour("00");
                dateEndWithTime.minutes("00");
                this.newItem.dateTimeEndUTC = dateEndWithTime._d;
                var scope = this;
                setTimeout(function () {
                  scope.newItem.dateTimeEndUTC = null;
                }, 250);
              }
            }
          }
        } 
      }
    },
    'newItem.dateTimeEndUTC': function (newVal, oldVal){
      if(newVal){
        if(!oldVal || (oldVal && oldVal.toDateString() != newVal.toDateString())){
          var dateWithTime = moment(newVal);
          if(dateWithTime){
            dateWithTime.hour("00");
            dateWithTime.minutes("00");
            this.newItem.dateTimeEndUTC = dateWithTime._d;
          }
        }  
      }
    }
  },
  mounted() {
    window.scoper= this;
    var user = this.getCurUser;
    this.isHQUser = user.isHQUser != null ? user.isHQUser : false;
    this.setCurApp('sol_campaign');
    if(this.isHQUser){
      this.countryList = ((user && user.countries && user.countries.length) ? user.countries : null);
    }else{
      this.countryList = ((user && user.countries && user.countries.length) ? user.countries.filter(country => country.solEnable) : null);
    }

    this.filterObj.countryList = this.countryList;
    this.getAllModel()

    if(this.idCampaign){
      //this.findCampaignById(this.$route.params.idCampaign);
      if(this.$route.params.from == 'price_conf'){
        this.isFromPriceConf = true;

      }
    }
    else if (this.$route.params.filterObj) {
      if(this.$route.params.from == 'price_conf'){
        this.filterObj = this.defaultFilterObj;
        this.isFromPriceConf = true;
        this.filterObj.id = this.$route.params.filterObj.id;
        this.search();
        //this.findCampaignById(this.$route.params.idCampaign);
        
      } else if(this.$route.params.from == 'sol_campaign'){
        console.log("--")
        console.log(this.getOriginalCampaignObject)
        console.log("++++++++++")
        console.log(this.$route.params.filterObj)
        this.filterObj = this.getOriginalCampaignObject;
        this.search();
      }
      
    } else{
      this.refreshTable();
    }

    var oldcss = this.$el.querySelector("#overflow_nav_buttons").style.cssText
    this.$el.querySelector("#overflow_nav_buttons").style.cssText = oldcss + "-ms-grid-rows: (1fr)[7]; -ms-grid-columns: (1fr)[12];"

    var tableResponsive = document.getElementsByClassName('table-responsive')

    function closeTimeDatePickers() {
      var timepickers = document.getElementsByClassName('drop-down');
      var datepickers = document.getElementsByClassName('vdp-datepicker__calendar');
      // console.log(timepickers)
      // console.log(datepickers)
      for(var i = 0; i < timepickers.length ; i++) {
        timepickers[i].style.display = 'none'
      }
      for(var i = 0; i < datepickers.length ; i++) {
        datepickers[i].style.display = 'none'
      }
    }
    for(var i = 0; i < tableResponsive.length ; i++) {
      tableResponsive[i].addEventListener('scroll', (e) => {
        closeTimeDatePickers()
      });
    }
    
    this.initialResizeCheck(tableResponsive[0], 2000)
    }
}

window.adjustPositionTime = function(element) {
  var dropdown = element.querySelector('.dropdown');
  var offset = element.offsetTop;
  var currentRow = element.parentElement.parentElement.parentElement.parentElement.getAttribute('aria-rowindex');
  var rowCount = document.getElementById('table').rows.length - 1;
  var items = document.getElementById('perPage-dd').value;
  var rowDifference = rowCount - currentRow;

  // set approproate position relative to table size
  if(rowCount < 5) {
    dropdown.parentElement.style.position = "inherit"
  } else {
    dropdown.parentElement.style.position = "relative"
  }

  //detect if current row is too close to last row
  if(rowDifference < 3 ) {
    //current row is too close to the end of the table
    //detect if table is too small
    if(rowCount < 5){
      //rowcount is low, the table is too small
      if(element.classList.contains('modal-timepicker')) {
        //ignore for modal timepicker
        dropdown.style.top = '2.2em';
      } else {
        //adjust accordingly
        if(currentRow == '1'){
          dropdown.style.top = '37px';
        } else if (currentRow == '2') {
          dropdown.style.top = '98px';
        } else if (currentRow == '3') {
          dropdown.style.top = '159px';
        }
      }
    } else {
      //rowcount is ok
      if(element.classList.contains('modal-timepicker')) {
        dropdown.style.top = '2.2em';
      } else {
        dropdown.style.top = 'calc(-10em - 1px)';
      }
    }

    //show timepicker
    setTimeout(() => {
      if(dropdown.style.opacity != 0 || dropdown.style.display == 'none'){
        dropdown.style.opacity = 0;
      } else {
        dropdown.style.opacity = 1;
      }
    }, 150)
  } else {
    //current row is NOT close to the end of the table
    //detect if table is too small
    if(rowCount < 5){
        //table is too small and needs to be managed
        if(currentRow == '1'){
          dropdown.style.top = '37px';
        } else if (currentRow == '2') {
          dropdown.style.top = '98px';
        } else if (currentRow == '3') {
          dropdown.style.top = '153px';
        } else if (currentRow == '4') {
          dropdown.style.top = '220px';
        } else if (currentRow == '5') {
          dropdown.style.top = '281px';
        }
    } else {
        dropdown.style.top = '2.15em';
    }
    setTimeout(() => {
      if(dropdown.style.opacity != 0 || dropdown.style.display == 'none'){
        dropdown.style.opacity = 0;
      } else {
        dropdown.style.opacity = 1;
      }
    }, 150)
  }
};

window.adjustPositionDate = function(element) {
  var calendar = element.querySelector('.vdp-datepicker__calendar');
  var offset = calendar.offsetTop
  var currentRow = element.parentElement.parentElement.parentElement.parentElement.getAttribute('aria-rowindex');
  var rowCount = document.getElementById('table').rows.length - 1;
  var items = document.getElementById('perPage-dd').value;
  var rowDifference = rowCount - currentRow;

  if(rowCount < 5 || rowDifference < 3) {
    calendar.style.transform = 'translate(-1px,-290px)';
  } else {
    calendar.style.transform = 'translate(0,0)';
  }
};

</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
.datepicker {
  width: 100%;
}
</style>
